import { type Shape } from '../components/base/shapes/shape-paths'
import { SELF_PERSPECTIVE_KEY, type Perspective } from './perspective'

const perspectiveKey = (perspective: Perspective | string) =>
  typeof perspective === 'string' ? perspective : perspective.key

export const iconForPerspective = (perspective: Perspective | string) => {
  if (perspectiveKey(perspective) == SELF_PERSPECTIVE_KEY) {
    return iconForSelfFeedback()
  }
  if (typeof perspective !== 'string') {
    return perspective.icon
  }
  return 'groups'
}

export const iconForSelfFeedback = () => {
  return 'account_circle'
}

const SELF_SHAPE: Shape = 'circle'

/**
 * Self always gets `circle`. Every other key gets the n-th shape in
 * `PERSPECTIVE_SHAPES`, where n is its index among non-self topic perspectives.
 */
export const shapeForPerspective = (perspective: Perspective | string): Shape => {
  const key = perspectiveKey(perspective)
  if (key === SELF_PERSPECTIVE_KEY) {
    return SELF_SHAPE
  }

  return 'square'
}

export const colorClassesForPerspective = (
  perspective: Perspective | string,
  allPerspectives: ReadonlyArray<Perspective>,
  type?: 'svg' | 'icon',
): string => {
  const key = perspectiveKey(perspective)

  if (key === SELF_PERSPECTIVE_KEY) {
    if (type === 'icon') {
      return ' text-on-primary'
    }
    if (type === 'svg') {
      return 'text-primary fill-primary'
    }

    return 'bg-primary text-on-primary'
  }
  const index = allPerspectives
    .filter((p) => p.key !== SELF_PERSPECTIVE_KEY)
    .findIndex((p) => p.key === key)
  if (index === 0) {
    if (type === 'icon') {
      return 'text-on-primary-container'
    }
    if (type === 'svg') {
      return 'text-primary-container fill-primary-container stroke-primary'
    }

    return 'bg-primary-container text-on-primary-container border-primary border'
  }

  if (type === 'svg') {
    return 'text-on-primary fill-on-primary stroke-primary'
  }
  if (type === 'icon') {
    return 'text-primary'
  }

  return 'bg-surface-container-lowest border-primary text-primary border'
}

export const shapeClassesForPerspective = (
  perspective: Perspective | string,
  allPerspectives: ReadonlyArray<Perspective>,
) => {
  const key = perspectiveKey(perspective)
  if (key === SELF_PERSPECTIVE_KEY) {
    return 'rounded-full! h-full w-full'
  }
  const index = allPerspectives
    .filter((p) => p.key !== SELF_PERSPECTIVE_KEY)
    .findIndex((p) => p.key === key)
  if (index === 0) {
    return 'rounded-[30%]! h-full w-full'
  }
  if (index === 1) {
    return 'rounded-[30%] rotate-45 h-[90%] w-[90%]'
  }
  return 'rounded-full h-full w-full'
}

export const iconColorClassesForPerspective = (
  perspective: Perspective | string,
  allPerspectives: ReadonlyArray<Perspective>,
): string => {
  const key = perspectiveKey(perspective)
  const index = allPerspectives.findIndex((p) => p.key === key)
  if (index === 0) {
    return 'text-on-primary-container'
  }
  if (index === 1) {
    return 'text-on-primary'
  }
  return 'text-primary'
}

/** @deprecated Prefer string perspective keys from analysis payloads */
export enum FeedbackPerspective {
  Self = 'self',
  Peer = 'peer',
  External = 'external',
}
